import { Tabs as MuiTabs, TabsProps, withStyles } from '@material-ui/core';
import { FC } from 'react';

import { styles } from './Tabs.styles';

const CustomTabs = withStyles(styles)(MuiTabs);

export const Tabs: FC<TabsProps> = props => <CustomTabs {...props}>{props.children}</CustomTabs>;
